import { IPositionTypeService } from "../../service/position/PositionTypeService";
import { IPositionType } from "../../model/position/PositionType";

export default class CreatePositionInteractor {
  private positionTypeService: IPositionTypeService;

  constructor(positionTypeService) {
    this.positionTypeService = positionTypeService;
  }

  async execute(position: IPositionType) {
    return this.positionTypeService.createPositionType(position);
  }
}
